import api from '../api';
import Axios from 'axios';
import { getJwt } from '@app/helpers';

export interface SeguroGarantia {
  id: string;
  descricao?: string;
  nome?: string;
  numero?: number;
  vigenciaInicio?: Date;
  vigenciaFim?: Date;
  status?: string;
  tipoDocumentoSeguroGarantiaId?: string;
  contratoId: string;
  nomeArquivo?:string;
  localArquivo?:string;
}

export const getAllSeguroGarantias = (contratoId: any) =>
  api.get<SeguroGarantia[]>(`documentossegurogarantia/contrato/${contratoId}`);

export const createSeguroGarantia = (file: any, SeguroGarantia: SeguroGarantia, contratoId:string) => {
  const form = new FormData();
  SeguroGarantia.contratoId = contratoId;
  Object.keys(SeguroGarantia).forEach(key => {
    form.append(key, SeguroGarantia[key]);
  });
  form.append('file', file);

  return api.post(`documentossegurogarantia`, form, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const updateSeguroGarantia = (file: any, SeguroGarantia: SeguroGarantia, contratoId:string) => {
  const form = new FormData();
  SeguroGarantia.contratoId = contratoId;
  Object.keys(SeguroGarantia).forEach(key => {
    form.append(key, SeguroGarantia[key]);
  });
  form.append('file', file);

  return api.put(`documentossegurogarantia/${SeguroGarantia.id}`, form, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const deleteSeguroGarantia = (id: any) => {return api.delete(`documentossegurogarantia/${id}`)};

export const download = (path: string, fileName: string) => {
  Axios.get(`/api/documentossegurogarantia/contrato/download?path=${path}&fileName=${fileName}`, {
    headers: {
      Authorization: `Bearer ${getJwt()}`,
    },
    responseType: 'blob',
  }).then(resp => {
    const url = window.URL.createObjectURL(new Blob([resp.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    link.setAttribute('id', 'downloadElement');
    document.body.appendChild(link);
    link.click();
    document.getElementById('downloadElement').outerHTML = '';
  });
};
